export const navItems = [
	{ alias: 'profile', title: 'ЛИЧНЫЙ КАБИНЕТ' },
	{ alias: 'favorite', title: 'ИЗБРАННОЕ' },
	{ alias: 'history', title: 'ИСТОРИЯ ЗАКАЗОВ' },
	{ alias: 'discount', title: 'АКТИВАЦИЯ ДИСКОНТНОЙ КАРТЫ'},
	// { alias: 'payment', title: 'ПЛАТЕЖНЫЕ ДАННЫЕ' },
]
